/* tslint:disable */
import * as React from "react";

const SvgDownChevWhite = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 32 40" {...props}>
    <path
      d="M22.71 12.29a1 1 0 0 0-1.42 0L16 17.59l-5.29-5.3a1 1 0 0 0-1.42 1.42l6 6a1 1 0 0 0 1.42 0l6-6a1 1 0 0 0 0-1.42z"
      fill="#fff"
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default SvgDownChevWhite;